import Immutable from 'immutable';
import i18n from '@i18n';
import axios from 'axios';

export function createPrematchSelectionsGrid(betslipPick) {
    const selections = betslipPick.getIn(['selections']);
    const positions = betslipPick.getIn(['positions', 'Mobile']);

    if (!positions) {
        return Immutable.List();
    }

    return selections
        .reduce((acc, selection) => {
            const selectionPosition = positions.get(selection.get('selectionCode'));
            const row = selectionPosition.get('row');
            const col = selectionPosition.get('col');

            if (!acc.getIn([row])) {
                acc = acc.setIn([row], Immutable.List());
            }

            selection = enrichBetslipSelection(selection);

            // 'p' je pridane k betId v Tips automaticky, bez toho aby sme ho tu odstranili by betId v Tips componente vyzeralo pp:urn ..
            selection.set('betId', normalizePrematchBetId(selection.get('betId')));

            return acc.setIn([row, col], selection);
        }, Immutable.List())
        .map(row => (row ? row : Immutable.List()));
}

export function createLiveSelectionsGrid(betslipPick) {
    const selections = betslipPick.getIn(['selections']);
    let row = 0;
    let col = 0;
    return selections
        .reduce((acc, selection) => {
            if (!acc.getIn([row])) {
                acc = acc.setIn([row], Immutable.List());
            }

            selection = enrichBetslipSelection(selection);

            // 'l' je pridane k betId v BetSelections automaticky, bez toho aby sme ho tu odstranili by betId v componente vyzeralo ll: ..
            selection.set('betId', normalizeLiveBetId(selection.get('betId')));

            acc = acc.setIn([row, col], selection);
            row++;
            return acc;
        }, Immutable.List())
        .map(row => (row ? row : Immutable.List()));
}

function enrichBetslipSelection(selection) {
    selection = selection.set('tip', selection.get('selectionCode'));
    selection = selection.set('name', selection.get('header'));
    return selection;
}

export function normalizePrematchBetId(betId) {
    return betId.charAt(0) === 'p' ? betId.slice(1) : betId;
}
export function normalizeLiveBetId(betId) {
    return betId.charAt(0) === 'l' ? betId.slice(1) : betId;
}

export function countValidItemsInGrid(grid) {
    return grid.filter(Boolean).reduce((totalCount, selectionRow) => {
        const rowCount = selectionRow.reduce((rowCount, selection) => {
            if (selection && selection.size) {
                return rowCount + 1;
            } else {
                return rowCount;
            }
        }, 0);
        return totalCount + rowCount;
    }, 0);
}

export const getSportEventsId = sportEvent => sportEvent.get('betEventId').replace(/[^\d]/g, '');

export function getEventType(type) {
    switch (type) {
        case 'Live':
            return i18n('event.flag.live');
        case 'Prematch':
            return i18n('event.flag.prematch');
        case 'Virtual':
            return i18n('event.flag.virtual');
        default:
            return null;
    }
}

export const getTicketsCount = (id, date) => axios.get(`/api/tournaments/${id}/ticketsCount/${date}`);
